import { blue, CircularProgress, Text } from "@flat-ui";
import { Stack, SxProps, Theme } from "@mui/material";
import { snapshotsBeingCreatedCountSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";

interface Props {
  /** Optional styles applied to the wrapper */
  sx?: SxProps<Theme>;
}

/**
 * Renders a blue text with a small spinner indicating how many snapshots are
 * currently being created. Renders `null` when no snapshots are being created.
 */
export function SnapshotsBeingCreatedIndicator({
  sx,
}: Props): JSX.Element | null {
  const snapshotsBeingCreatedCount = useAppSelector(
    snapshotsBeingCreatedCountSelector
  );

  if (snapshotsBeingCreatedCount === 0) {
    return null;
  }

  const snapshotLabel = nounPluralize({
    counter: snapshotsBeingCreatedCount,
    word: "snapshot",
    shouldShowCounter: false,
  });

  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1, ...sx }}>
      <CircularProgress size="1rem" sx={{ color: blue[500] }} />
      <Text variant="bodyM" sx={{ color: blue[500] }}>
        <var>{snapshotsBeingCreatedCount}</var> {snapshotLabel} being created
      </Text>
    </Stack>
  );
}
